import { fetcher } from 'components/shared/fetcher.js'
import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { createAwaitable } from '@cloudsuite/mosaic-shared/scripts/create-awaitable.js'

const [rmaBaseUrl, setRmaBaseUrl] = createAwaitable<string>({ name: 'rmaBaseUrl' })
export { setRmaBaseUrl }

export const executeRmaRequest = async <T, E>(request: RmaRequest<T, E>): Promise<T | E> => {
  const url = new URL(request.path, await rmaBaseUrl())
  const response = await fetcher.fetch(url, request.init)
  const data: unknown = await parseDataFromResponse(response)

  if (response.ok) return request.parseResponse?.(data) as T

  const error = request.parseError(response.status, data)
  // Expected errors (e.g. a 400 validation failure) are returned for the caller
  // to surface; anything unexpected is thrown so it can't masquerade as success.
  if (!request.expectedErrors.includes(response.status)) throw error
  return error as E
}

const parseDataFromResponse = async (response: Response): Promise<unknown> => {
  const nullBodyStatuses = [101, 103, 204, 205, 304]

  if (nullBodyStatuses.includes(response.status)) return null

  const text = await response.text()
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch {
    // An error response may carry an HTML body (e.g. an uncaught server-side
    // exception) — hand the raw text to the error parser rather than crashing.
    return text
  }
}
